import {SearchCondition} from "./SearchCondition";

export type SearchConditionElement<T> = {
    name: Extract<keyof T, string>
    value: string
    condition: SearchCondition
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace SearchConditionElement {
    export function stringify<T>(element: SearchConditionElement<T>): string {
        return `${element.name}${element.condition}=${encodeURIComponent(element.value.toString())}`
    }

    export function join<T>(elements: SearchConditionElement<T>[]): string {
        return elements.map(stringify).join('&')
    }
}

